import React, { useEffect, useState } from 'react';
import { MdAccountBalance, MdConnectedTv, MdDashboard, MdGroup, MdHome, MdLocalPostOffice, MdLogout, MdOutlineSettings, MdShieldMoon, MdChat,MdEvent   } from 'react-icons/md';
import { NAVIGATION } from '../lib/navigation';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectLoggedInData } from '../store/slices/api/auth/loginSlice';
import _ from 'lodash'

export const menuItems = [
    { name: "Dashboard", key: "dashboard", icon: <MdHome className='text-xl' />, href: NAVIGATION.INNER_NAVIGATION.DASHBOARD, bypassRole: true },
    {
        name: "Masters",
        key: "master",
        icon: <MdDashboard className='text-xl' />,
        submenu: [
            { name: "Banner", key: "banner", href: NAVIGATION.INNER_NAVIGATION.MASTERS.BANNER, showInMenu: true },
            { name: "Partners", key: "partners", href: NAVIGATION.INNER_NAVIGATION.MASTERS.PARTNERS, showInMenu: true },
            { name: "Team Members", key: "teamMembers", href: NAVIGATION.INNER_NAVIGATION.MASTERS.TEAM_MEMBERS, showInMenu: true },
            { name: "Update Team Members", key: "updateteamMembers", href: NAVIGATION.INNER_NAVIGATION.MASTERS.UPDATE_TEAM_MEMBERS, showInMenu: false },
            { name: "Add Team Members", key: "addteamMembers", href: NAVIGATION.INNER_NAVIGATION.MASTERS.ADD_TEAM_MEMBERS, showInMenu: false },
            { name: "Skill Type", key: "skillType", href: NAVIGATION.INNER_NAVIGATION.MASTERS.SKILL_TYPE, showInMenu: true },
            { name: "Skills", key: "skills", href: NAVIGATION.INNER_NAVIGATION.MASTERS.SKILLS, showInMenu: true },
            { name: "Industries", key: "industries", href: NAVIGATION.INNER_NAVIGATION.MASTERS.INDUSTRIES, showInMenu: true }
        ]
    },
    {
        name: "Blog",
        key: "blog",
        icon: <MdConnectedTv className='text-xl' />,
        submenu: [
            { name: "Categories", key: "categories", href: NAVIGATION.INNER_NAVIGATION.BLOGS.BLOG_TYPES, showInMenu: true },
            { name: "Blog Post", key: "blogPost", href: NAVIGATION.INNER_NAVIGATION.BLOGS.BLOGS, showInMenu: true },
            { name: "Add Blog Post", key: "editblogPost", href: NAVIGATION.INNER_NAVIGATION.BLOGS.UPDATE_BLOG, showInMenu: false },
            { name: "Edit Blog Post", key: "addblogPost", href: NAVIGATION.INNER_NAVIGATION.BLOGS.ADD_BLOG, showInMenu: false },
        ]
    },
    {
        name: "Users",
        key: "users",
        icon: <MdGroup className='text-xl' />,
        submenu: [
            { name: "CV/Resumes", key: "cvResume", href: NAVIGATION.INNER_NAVIGATION.USERS.CVS, showInMenu: true },
            { name: "Cover letters", key: "coverLetters", href: NAVIGATION.INNER_NAVIGATION.USERS.COVER_LETTER, showInMenu: true },
            { name: "Users list", key: "usersList", href: NAVIGATION.INNER_NAVIGATION.USERS.USER_LIST, showInMenu: true },
        ]
    },
    {
        name: "Jobs",
        key: "jobs",
        icon: <MdShieldMoon className='text-xl' />,
        submenu: [
            { name: "Pending", key: "pending", href: NAVIGATION.INNER_NAVIGATION.JOBS.PENDING_JOBS, showInMenu: true },
            { name: "Approved", key: "approved", href: NAVIGATION.INNER_NAVIGATION.JOBS.JOBS, showInMenu: true }
        ]
    },
    { name: "Admin Users", key: "members", icon: <MdGroup className='text-xl' />, href: NAVIGATION.INNER_NAVIGATION.MEMBER.MEMBERS },
    { name: "Enquiries", key: "enquiries", icon: <MdLocalPostOffice className='text-xl' />, href: NAVIGATION.INNER_NAVIGATION.ENQUIRIES },
    { name: "Networking", key: "events", icon: <MdEvent  className='text-xl' />, href: NAVIGATION.INNER_NAVIGATION.EVENTS },
    { name: "Chats", key: "chats", icon: <MdChat className='text-xl' />, href: NAVIGATION.INNER_NAVIGATION.CHATS },
    { name: "Transactions", key: "transactions", icon: <MdAccountBalance className='text-xl' />, href: NAVIGATION.INNER_NAVIGATION.TRANSACTION },
    {
        name: "Settings",
        key: "settings",
        icon: <MdOutlineSettings className='text-xl' />,
        submenu: [
            { name: "Fonts", key: "fonts", href: NAVIGATION.INNER_NAVIGATION.SETTING.FONTS, showInMenu: true },
            { name: "Change Password", key: "changePassword", href: NAVIGATION.INNER_NAVIGATION.SETTING.CHANGE_PASSWORD, showInMenu: true },
        ]
    },
    { name: "Logout", key: "logout", icon: <MdLogout className='text-xl' />, href: NAVIGATION.AUTH_NAVIGATION.LOGOUT, bypassRole: true },
];

const Sidebar = ({ isSidebarOpen }) => {
    const [isDropdownOpen, setDropdownOpen] = useState({});
    const loggedInData = useSelector(selectLoggedInData);
    const adminUserType = loggedInData?.authUserData?.admin_user_type;
    const adminRoles = JSON.parse(loggedInData?.authUserData?.admin_roles || '[]') || [];
    const location = useLocation();

    const toggleDropdown = (name) => {
        if (isDropdownOpen[name] !==name) {
            setDropdownOpen({ [name]: !isDropdownOpen[name] });
        }
    };

    // Function to find the parent name based on href
    function findParentNameByHref(href) {
        let parentName = null;
        // Iterate over each parent item in the menuItems array
        menuItems.forEach((parent, index) => {
            if (!parent?.submenu) {
                if (parent?.href === href) {
                    parentName = parent?.name;
                }
            } else {
                const el = _.find(parent?.submenu, { href });
                if (el) {
                    parentName = parent?.name;
                }
            }
        })
        return parentName;
    }

    useEffect(() => {
        const path = location?.pathname;
        const name = findParentNameByHref(path);
        if (isDropdownOpen[name] !== name) {
            setDropdownOpen({ [name]: true });
        }//eslint-disable-next-line
    }, [location])

    const hasAccess = (key) => {
        if (adminUserType === 'subadmin') {
            if (_.find(adminRoles, { key: key })) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    };

    const filteredMenuItems = menuItems
        .filter(item => hasAccess(item.key))
        .map(item => ({
            ...item,
            submenu: item.submenu?.filter(subItem => hasAccess(subItem.key))
        }));

    return (
        <aside
            className={`fixed top-4 md:top-16 left-0 z-10 w-64 h-screen transition-transform md:translate-x-0 ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} bg-gray-50`}
            aria-label="Sidebar"
        >
            <div className="h-full px-3 py-4 overflow-y-auto">
                <ul className="space-y-2 font-medium">
                    {filteredMenuItems.map((item, index) => (
                        <li key={index}>
                            {item.submenu ? (
                                <>
                                    <button
                                        type="button"
                                        className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-gray-100"
                                        onClick={() => toggleDropdown(item.name)}
                                    >
                                        {item.icon}
                                        <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap">{item.name}</span>
                                        <svg className={`w-3 h-3 transition-transform ${isDropdownOpen[item.name] ? 'rotate-180' : ''}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                                        </svg>
                                    </button>
                                    {isDropdownOpen[item.name] && (
                                        <ul className="py-2 space-y-2">
                                            {item.submenu.map((subItem, subIndex) => (
                                                subItem?.showInMenu && (
                                                    <li key={subIndex} onClick={() => toggleDropdown(item.name)}>
                                                        <Link to={subItem.href} className="flex items-center w-full p-2 text-gray-900 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100">
                                                            {subItem.name}
                                                        </Link>
                                                    </li>
                                                )
                                            ))}
                                        </ul>
                                    )}
                                </>
                            ) : (
                                <Link to={item.href} className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group">
                                    {item.icon}
                                    <span className="flex-1 ms-3 whitespace-nowrap">{item.name}</span>
                                </Link>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </aside>
    );
};

export default Sidebar;